import React, { Fragment } from 'react';
import { Input, Label } from 'reactstrap';
import { H4 } from '../../../AbstractElements';
import { buttonoutline, ButtonSize, ButtonStyle, Default, DefaultButton, Edgebutton, ExtraSmall, Flatbutton, gradien, Large, Raisedbutton, Small } from '../../../Constant';

const Btnstyle = ({ onSelectchange, onchangeSize }) => {
  return (
    <Fragment>
      <div className='col-xl-6'>
        <div>
          <H4 className='text-base'>{ButtonStyle}</H4>
        </div>
        <div>
          <div className='form-check'>
            <Input
              className='form-check-input'
              type='radio'
              name='Radio'
              id='Default'
              value=''
              defaultChecked
              onClick={(e) => {
                onSelectchange(e.target.value);
              }}
            />
            <Label className='form-check-label' htmlFor='Default'>
              {DefaultButton}
            </Label>
          </div>
          <div className='form-check'>
            <Input
              className='form-check-input'
              type='radio'
              name='Radio'
              id='Flatebtn'
              value='square'
              onClick={(e) => {
                onSelectchange(e.target.value);
              }}
            />
            <Label className='form-check-label' htmlFor='Flatebtn'>
              {Flatbutton}
            </Label>
          </div>
          <div className='form-check'>
            <Input
              className='form-check-input'
              type='radio'
              name='Radio'
              id='Edgebtn'
              value='pill'
              onClick={(e) => {
                onSelectchange(e.target.value);
              }}
            />
            <Label className='form-check-label' htmlFor='Edgebtn'>
              {Edgebutton}
            </Label>
          </div>
          <div className='form-check'>
            <Input
              className='form-check-input'
              type='radio'
              name='Radio'
              id='Raisebtn'
              value='air'
              onClick={(e) => {
                onSelectchange(e.target.value);
              }}
            />
            <Label className='form-check-label' htmlFor='Raisebtn'>
              {Raisedbutton}
            </Label>
          </div>
          <div className='form-check'>
            <Input
              className='form-check-input'
              type='radio'
              name='Radio'
              id='Outlinebtn'
              value='outline'
              onClick={(e) => {
                onSelectchange(e.target.value);
              }}
            />
            <Label className='form-check-label' htmlFor='Outlinebtn'>
              {buttonoutline}
            </Label>
          </div>
          <div className='form-check'>
            <Input
              className='form-check-input'
              type='radio'
              name='Radio'
              id='Gradienbtn'
              value='gradien'
              onClick={(e) => {
                onSelectchange(e.target.value);
              }}
            />
            <Label className='form-check-label' htmlFor='Gradienbtn'>
              {gradien}
            </Label>
          </div>
        </div>
      </div>
      <div className='col-xl-6'>
        <div>
          <H4 className='text-base'>{ButtonSize}</H4>
        </div>
        <div>
          <div className='form-check'>
            <Input
              className='form-check-input'
              type='radio'
              name='Radio1'
              id='defaultsize'
              defaultChecked
              value=''
              onClick={(e) => {
                onchangeSize(e.target.value);
              }}
            />
            <Label className='form-check-label' htmlFor='defaultsize'>
              {Default}
            </Label>
          </div>
          <div className='form-check'>
            <Input
              className='form-check-input'
              type='radio'
              name='Radio1'
              id='largesize'
              value='lg'
              onClick={(e) => {
                onchangeSize(e.target.value);
              }}
            />
            <Label className='form-check-label' htmlFor='largesize'>
              {Large}
            </Label>
          </div>
          <div className='form-check'>
            <Input
              className='form-check-input'
              type='radio'
              name='Radio1'
              id='smallsize'
              value='sm'
              onClick={(e) => {
                onchangeSize(e.target.value);
              }}
            />
            <Label className='form-check-label' htmlFor='smallsize'>
              {Small}
            </Label>
          </div>
          <div className='form-check'>
            <Input
              className='form-check-input'
              type='radio'
              name='Radio1'
              id='extrasmallsize'
              value='xs'
              onClick={(e) => {
                onchangeSize(e.target.value);
              }}
            />
            <Label className='form-check-label' htmlFor='extrasmallsize'>
              {ExtraSmall}
            </Label>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default Btnstyle;
